module.exports = __webpack_public_path__ + "static/media/gorillaPic.3ae4bfc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/gorillaPic.jpg
// module id = 72
// module chunks = 0